export enum ApiStatus {
  SUCCEEDED = "suc",
  IDLE = "idl",
  ERROR = "err",
  PENDING = "pen",
}
